import React from 'react';
import { StaticQuery, graphql } from 'gatsby';

import Carousel from './carousel';
import { stations } from '@data/benzinske-pumpe.json';

const StationCarousels = () => (
  <StaticQuery
    query={graphql`
      query {
        allFile(filter: { relativeDirectory: { eq: "pumpe" } }) {
          edges {
            node {
              relativePath
              childImageSharp {
                fluid(maxWidth: 800, quality: 80) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      const imageMap = {};
      data.allFile.edges.forEach(({ node }) => {
        imageMap[node.relativePath] = node.childImageSharp.fluid;
      });

      return (
        <section className="pb-0">
          <div className="container">
            {stations
              .filter(station => station.images)
              .map(station => {
                const images = station.images
                  .map(file => ({ fluid: imageMap[file] }))
                  .filter(img => img.fluid);

                if (!images.length) return null;

                return (
                  <div key={`pumpa-${station.name}`}>
                    <Carousel
                      name={station.name}
                      title={station.name}
                      location={station.location}
                      time={station.work_time}
                      images={images}
                      altText="Benzinska pumpa"
                    />
                  </div>
                );
              })}
          </div>
        </section>
      );
    }}
  />
);

export default StationCarousels;
